import { type JSX } from 'react';

import { createFileRoute } from '@tanstack/react-router';

import { CollectionsPage } from '@/features/themes/pages/CollectionsPage';

export const Route = createFileRoute('/banco-de-temas/colecoes')({
  component: ColecoesTab,
});

function ColecoesTab(): JSX.Element {
  return <CollectionsPage />;
}
